module.exports = __webpack_public_path__ + "img/img3-opt.8d4a23a7.jpg";